import React, { Component } from 'react';
import { Modal, ModalBody } from "reactstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons'
import './new-test.scss';
import { Constants, ImageConstants } from '../../../constants/constants';
import { getImageSource } from '../../../utility/image-source'
import Filter from './filter/filter'
import QuestionList from './questions-list-v2/questions-list'
import SchoolUserApi from '../../../apis/student'
import QuestionSetApi from '../../../apis/question-set'
import CommonUtils from '../../../utility/common-utilities'
import TestApi from '../../../apis/test'
import Dropdown from '../../common/dropdown/dropdown';
import CWConfirm from '../../common/cw-confirmation-modal/cw-confirmation-modal'
import MasterDataApi from '../../../apis/master-data';
import AddQuestion from '../../question-bank/add-question/add-question';
import SessionCache from '../../routes/session-cache';
import ToasterComponent from '../../common/cw-toaster-component/cw-toaster-component';

class NewHomeWork extends Component {

    state = {
        isAdaptive: false,
        numberOfQuestions: 0,
        approximateTime: 0,
        studentList: [],
        useGeneratedQuestions: true,
        generateQuestions: false,
        questions: [],
        selectedQuestions: [],
        selectedQuesByChapter: {},
        selectedQuesByComplexity: {},
        complexityList: [],
        activeTabIndex: 0,
        showAnswer: [],
        selectedQuestionMenu: 1,
        selectedTab: 2,
    }

    tabs = [
        {
            title: 'Questions List',
            value: 2
        },
        {
            title: 'All Students',
            value: 1
        }

    ]

    constructor(props) {
        super(props)
        this.user = SessionCache.getUser()
    }


    componentDidMount() {
        this.getPracticeQuestionComplexity()
    }
    getPracticeQuestionComplexity = _ => {
        const { complexity } = this.state
        QuestionSetApi.getPracticeQuestionComplexity({})
            .then(response => {
                const complexityList = []
                response.map(res => {
                    if (res.title !== 'HOTS') {
                        complexityList.push({
                            value: res._id,
                            title: res.title
                        })
                    }
                })
                this.setState({
                    complexityList
                })
            })
            .catch(err => {
                console.log(err)
            })
    }

    onClickCreate = () => {

        let payload = this.state.payload || {}

        payload.type = this.props.type === "DIAGNOSTIC" ? "DIAGNOSTIC" : "CLASSWORK_ASSESSMENT"

        if (!payload.duration) payload.duration = this.state.approximateTime || 0
        if (payload.questionSource === "questionbank") {
            payload.duration = this.getEstimatedTime()
        }
        payload.questions = this.getQuestionPayload(this.state.questions || [])
        let validation = this.validatePayload(payload)

        if (!validation) return

        this.setState({ isLoading: true })

        TestApi.createTest(payload).then(response => {
            this.saving = false
            this.setState({ isLoading: false, showPickQuestions: false })
            let assessment = { ...response.data, ...payload, created: true }
            if (!assessment.totalUsers) {
                this.props?.delegate?.onCLickNotitification && this.props.delegate.onCLickNotitification(assessment, "WHATSAPP")
            } else {
                this.props?.delegate?.showSuccessModal && this.props.delegate.showSuccessModal(assessment)

            }
            if (assessment.point) {
                this.props?.delegate?.showRewardToaster && this.props.delegate.showRewardToaster(assessment.point)
            }
            this.props?.delegate?.hideNewTest && this.props.delegate.hideNewTest(true)
        }).catch(err => {

            this.saving = false

            this.setState({ isLoading: false })
        })

    }

    getQuestionPayload(questions) {
        let result = questions.map(item => {
            item.mark = item?.content?.mark || CommonUtils.getMarkByComplexity(item?.content?.complexity)
            item.duration = item.duration
            delete item.content
            return item
        })
        if (this.state.selectedContentAssessment) {
            let contentIdList = []

            for (let key in this.state.contentsHash) {
                let item = this.state.contentsHash[key]
                if (item.selected) {
                    contentIdList.push(key)
                }
            }

            let filtered = questions.filter(item => contentIdList.includes(item.id))

            console.log(filtered)

            filtered.forEach(item => {
                if (this.state.contentsHash[item.id]) {
                    item.duration = this.state.contentsHash[item.id].duration
                }
            })

            result = filtered
        }

        return result
    }

    getQuestionList(payload = {}) {
        payload.chapterKey = this.state.payload?.chapters?.map(item => item.key)
        payload.class = this.state.payload?.class
        payload.duration = this.state.payload?.duration

        if (this.props.type === 'CLICKER_ASSESSMENT') {
            payload.type = this.props.type
        }

        console.log(payload)

        if (payload.chapterKey.length > 1 && this.state.payload.questionCount) {
            payload.questionCount = this.state.payload.questionCount
        }

        if (!payload.chapterKey?.length) {
            console.log(payload)
            this.setState({
                isLoading: true, questions: [], questionCount: 0,
                approximateTime: 0,
                contents: []
            }, () => {
                this.setState({ isLoading: false })
            })
            return
        }

        if (payload.chapterKey?.length > 1 && !payload.questionCount) {
            this.setState({ questions: [], approximateTime: null })
            return
        }

        if (this.state.showCompetencyQuestionsOnly) {
            payload.showCompetencyQuestionsOnly = true
        }



        payload.chapterKey = payload.chapterKey.join(",")

        if (this.state.payload?.selectedQuestionSetId) {
            payload.selectedQuestionSetId = this.state.payload?.selectedQuestionSetId
        }

        this.setState({ isLoading: true, questions: [] })

        // if (this.props.type === "DIAGNOSTIC") {
        //     TestApi.getDiagnosticQuestionList(payload)
        //         .then(response => {

        //             this.setState({ questions: response?.questions, isLoading: false })
        //         }).catch(err => {
        //             this.setState({ isLoading: false, questions: [] })
        //         })
        // } else {
        TestApi.getAssessmentQuestionList(payload)
            .then(response => {
                if (response.questions && response.questions.length > 0) {
                    response.questions.map(question => {
                        if (!question.mandatoryAttachments) {
                            question.mandatoryAttachments = {
                                video: false,
                                audio: false,
                                image: false
                            }
                        }
                        return question
                    })
                }
                this.setState({
                    questions: response?.questions, contents: response?.questions,
                    isLoading: false, approximateQuestions: response?.questions.length,
                    questionCount: response?.questions.length,
                    approximateTime: response.approximateTime
                })
            }).catch(err => {
                this.setState({
                    isLoading: false, questions: [], questionCount: 0,
                    approximateTime: 0,
                    contents: []
                })
            })
        // }
    }


    getAssessmentAllQuestionsList() {

        if (!this.state.payload.class) return
        let payload = {}

        payload.board = this.state.payload?.board
        payload.class = this.state.payload?.class
        // payload.medium = this.state.payload?.medium
        payload.type = 'CLASS_MOCK_TEST'

        TestApi.getAssessmentAllQuestionList(payload).then(response => {

            if (response.questions && response.questions.length > 0) {
                response.questions.map(question => {
                    if (!question.mandatoryAttachments) {
                        question.mandatoryAttachments = {
                            video: false,
                            audio: false,
                            image: false
                        }
                    }
                    return question
                })
            }



            this.setState({ questions: response.questions || [], duration: response.duration }, () => {
                // this.showQuestionList(response)
            })

        }).catch(err => {
            console.log(err)
        })
    }

    getStudent() {

        let payload = {
            class: this.state.payload?.class,
            board: this.state.payload?.board,
            verified: true,
            rollNumber: true,
            isForQuiz: false
        }

        if (this.state.payload.sectionId) payload.sectionId = this.state.payload.sectionId

        if (!payload.board || !payload.class) return

        SchoolUserApi.getSchoolUsers(payload)
            .then(response => {
                let list = [], studentList = response?.response

                console.log(studentList)

                for (let i = 0; i < studentList.length; i += 3) {
                    let students = studentList.slice(i, i + 3)
                    list.push(students)
                }

                if (!list.length) {
                    this.setState({ studentList: list, noStudentsFound: true, studentListLength: studentList.length })
                } else {
                    this.setState({ studentList: list, noStudentsFound: false, studentListLength: studentList.length })
                }
            }).catch(err => {
                this.setState({ totalStudents: 0 })
            })
    }
    validatePayload(payload, leaveQuestions) {


        if (this.user.subjectId === Constants.SCIENCE_SUBJECTID && !payload.subSubjectId) {
            this.setState({ errMessage: "Please Select the Subject" })
            return false
        }

        if (!payload?.board) {
            this.setState({ errMessage: "Please Select the Board" })
            return false
        }

        if (!payload?.class) {
            this.setState({ errMessage: "Please Select the Class" })
            return false
        }

        // if (!payload.section) {
        //     this.setState({ errMessage: "Please Select the section" })
        //     return false
        // }

        if (!payload.chapters?.length) {
            this.setState({ errMessage: "Please Select the Chapters" })
            return false
        }

        if (payload.chapters?.length > 1 && !payload.duration) {
            this.setState({ errMessage: "Please Select the Duration" })
            return false
        }

        if (!payload.dueDate) {
            this.setState({ errMessage: "Please Select the Due Date" })
            return false
        }

        if (!leaveQuestions && !payload?.questions?.length) {
            this.setState({ errMessage: "No Questions Available in these Chapters" })
            return false
        }

        this.setState({ errMessage: "" })
        return true
    }


    onClickBack = () => {
        this.props?.delegate?.hideNewTest && this.props.delegate.hideNewTest()
    }


    hideInfoModal = () => {
        this.setState({ showInfoModal: false })
    }

    showConfirmModal = index => {
        const { questions } = this.state
        const question = questions[index]
        let deleteMessage = `Are you sure you want to remove the following Question?`
        this.setState({
            deleteIndex: index,
            showConfirmModal: true,
            deleteMessage,
            selectedContent: question.content?.title.replace(/<(.|\n)*?>/g, '').replace(/\&nbsp;/g, " ")
        })
    }

    removeSelectedQuestion = _ => {
        const { toRemoveQuestion, toRemoveFromChapter } = this.state
        this.setState({
            showQuestionRemoveConfirmModal: false
        }, _ => {
            this.onSelectQuestion(toRemoveQuestion, toRemoveFromChapter)
        })
    }

    showQuestionRemoveConfirmModal = (question, chapter) => {
        let deleteMessage = `Are you sure you want to remove the following Question?`
        let deleteDescription = question.content?.title.replace(/<(.|\n)*?>/g, '').replace(/\&nbsp;/g, " ")
        this.setState({
            toRemoveQuestion: question,
            toRemoveFromChapter: chapter,
            showQuestionRemoveConfirmModal: true,
            deleteMessage,
            deleteDescription
        })
    }

    hideConfirmModal = () => {
        this.setState({ showConfirmModal: false, showQuestionRemoveConfirmModal: false })
    }

    onDeleteQuestion = _ => {
        const { deleteIndex, questions } = this.state
        questions.splice(deleteIndex, 1)
        this.setState({ questions, showConfirmModal: false })
    }

    openAddQuestion = _ => {
        this.setState({
            openAddQuestion: true
        })
    }

    hideAddQuestion = _ => {
        this.setState({
            openAddQuestion: false
        })
    }

    addQuestionsSuccess = (isAdd, isError, errorCode, question) => {
        const { questions } = this.state
        questions.push(question)
        this.setState({
            questions,
            openAddQuestion: false
        })
    }

    pickFromBank = (step, appendQuestions) => {
        let payload = this.state.payload || {}
        payload.type = this.props.type === "DIAGNOSTIC" ? "DIAGNOSTIC" : "CLASSWORK_ASSESSMENT"
        if (!payload.duration) payload.duration = this.state.approximateTime || 0
        let validation = this.validatePayload(payload, true)
        if (!validation) return

        this.setState({
            openQuestionOptions: false,
            step
        }, _ => {
            const selectedClass = { value: this.state.payload?.class }
            const chapters = []
            if (this.state.payload?.chapters?.length > 0) {
                this.state.payload.chapters.map(item => {
                    chapters.push({
                        value: item.key,
                        title: item.title
                    })
                })
            }
            this.showPickQuestions(
                selectedClass,
                chapters,
                true
            )
        })
    }

    showQuestionDetail = () => {
        return (
            <div className="question-list header-image">
                <div>
                    {
                        this.state.questions?.length ?
                            <QuestionList
                                pickFromBank={this.pickFromBank}
                                openAddQuestion={this.openAddQuestion}
                                saveQuestions={this.saveQuestions}
                                questions={this.state.questions || []}
                                onDeleteQuestion={this.showConfirmModal}
                                payload={this.state.payload}
                            />
                            : ""
                    }
                    <div className='text-center next-button'>
                        {this.state.questions?.length > 0 &&
                            <>
                                <button className='cw-btn-md cw-btn-primary' onClick={_ => this.pickFromBank(1)}>
                                    Back
                                </button>
                                <button className='cw-btn-md cw-btn-primary' onClick={this.goToNextStep}>
                                    NEXT
                                </button>
                            </>
                        }
                    </div>
                </div>
            </div>
        )

    }

    onSelectDropDown(option, cardInfo, index) {
        cardInfo.selectedCriterion = option?.value
        let categories = this.state.categories
        categories[index] = cardInfo
        this.setState({ categories })
    }

    getChapterList = className => {
        if (!className) return
        const payload = {
            class: className
        }
        MasterDataApi.getChapterList(payload)
            .then(response => {
                const chapterList = []
                if (response.data.chapters && response.data.chapters.length) {
                    response.data.chapters.forEach(chapter => {
                        chapterList.push({
                            title: chapter.title,
                            value: chapter.key
                        })
                    })
                }
                this.setState({
                    chapterList
                })
            })
            .catch(err => {
                console.log(err)
            })
    }

    resetSelectedQuestions = _ => {
        this.setState({
            selectedQuestions: []
        })
    }

    showPickQuestions = (selectedClass, selectedChapters, appendQuestions) => {
        const { payload } = this.state;
        this.setState({
            showPickQuestions: true,
            appendQuestions: appendQuestions ? appendQuestions : false,
            selectedChapters
        }, _ => {
            const selectedChapter = selectedChapters && selectedChapters?.length > 0 ? selectedChapters[0] : {}
            this.setState({
                selectedChapter
            }, _ => {
                this.getChapterList(selectedClass?.value)
                this.getSchoolQuestionSet()
            })
        })
    }

    hidePickQuestions = _ => {
        this.setState({
            showPickQuestions: false,
            questionSet: {},
            appendQuestions: false,
            complexity: ""
        })
    }

    onBoardChange = _ => {
        this.setState({
            selectedQuestions: [],
            questions: [],
            selectedQuesByChapter: {},
            selectedQuesByComplexity: {}
        })
    }

    handleFilter = (payload, reloadQuestion, reloadStudent) => {
        this.setState({ payload }, () => {
            if (payload.questionSource !== "questionbank") {

                if (payload.assessmentType === 'DIAGNOSTIC') {
                    reloadQuestion && this.getQuestionList()
                }


            }
            reloadStudent && this.getStudent()
        })
    }

    showCompetencyQuestionsOnly(showCompetency) {
        this.setState({ showCompetencyQuestionsOnly: showCompetency }, () => {
            this.getQuestionList()
        })

    }

    refreshQuestionList = () => {
        this.getQuestionList()
    }

    onClickReview = () => {
        this.setState({ showQuestionList: true })
    }

    hideReview = () => {
        this.setState({ showQuestionList: false })
    }

    onChangeHandler = (event, key) => {
        this.setState({ [key]: event.target.value }, _ => {
            if (key === "search") {
                // this.getSchoolQuestionSet()
            }
        })
    }

    onSelect = (option, key) => {
        this.setState({ [key]: option }, _ => {
            this.setState({ showAnswer: [] }, _ => {
                if (key === "selectedChapter" || key === "complexity") {
                    // this.setState({questionSet: {}}, _ => {
                    // this.getSchoolQuestionSet()
                    // })
                }
            })
        })
    }

    getSchoolQuestionSet = () => {
        const { selectedChapter, search, complexity } = this.state
        if (!selectedChapter || !selectedChapter?.title) return
        const payload = {
            chapterKey: selectedChapter?.value
        }
        if (search && search.length > 2) {
            payload.searchText = search
        }
        if (complexity?.value) {
            payload.complexityId = complexity?.value
        }
        TestApi.getSchoolQuestionSet(payload)
            .then(response => {
                this.setState({
                    questionSet: response.questionSet
                })
            })
            .catch(err => {
                this.setState({
                    questionSet: {}
                })
                console.log(err)
            })
    }

    onSelectQuestion = (question, chapter) => {
        const { selectedQuestions, selectedChapter, selectedQuesByChapter, selectedQuesByComplexity } = this.state
        const currentChapter = chapter || selectedChapter?.title
        const complexity = question.content?.complexity
        if (!selectedQuesByChapter[currentChapter]) selectedQuesByChapter[currentChapter] = []
        if (!selectedQuesByComplexity[complexity]) selectedQuesByComplexity[complexity] = []
        const idx = selectedQuestions.findIndex(q => question.id === q.id);
        if (idx >= 0) {
            selectedQuestions.splice(idx, 1)
            const scIdx = selectedQuesByChapter[currentChapter].findIndex(sc => question.id === sc.id);
            if (scIdx >= 0)
                selectedQuesByChapter[currentChapter].splice(scIdx, 1)
            const qcIdx = selectedQuesByComplexity[complexity].findIndex(sc => question.id === sc.id);
            if (qcIdx >= 0)
                selectedQuesByComplexity[complexity].splice(qcIdx, 1)
        } else {
            question.chapterKey = selectedChapter?.value;
            selectedQuesByChapter[currentChapter].push(question)
            selectedQuesByComplexity[complexity].push(question)
            selectedQuestions.push(question)
        }
        this.setState({
            selectedQuestions,
            selectedQuesByChapter,
            selectedQuesByComplexity
        })
    }

    setAssessmentQuestions = _ => {
        const { selectedQuestions, appendQuestions } = this.state
        let questions = this.state.questions || []
        if (this.state.payload?.questionSource === "countingwell") {
            selectedQuestions.map(sq => {
                const idx = questions.findIndex(q => q.id === sq.id)
                if (idx < 0) {
                    questions.push(sq)
                }
            })
        } else {
            questions = selectedQuestions
        }
        this.setState({ questions, appendQuestions: false }, _ => {
            this.goToNextStep()
        })
    }

    onClickTab = (tabIdx, title) => {
        this.setState(
            {
                activeTabIndex: tabIdx,
                selectedTabName: title
            },
            _ => {
            }
        )
    }

    getSkillImage = complexityId => {
        const { complexityList } = this.state
        const idx = complexityList.findIndex(c => c.value === complexityId)
        if (idx >= 0) {
            return getImageSource(ImageConstants["SKILL_" + complexityList[idx].title.toUpperCase() + "_ICN"])
        } else {
            return getImageSource(ImageConstants["SKILL_" + complexityList[0].title.toUpperCase() + "_ICN"])
        }
    }

    getSkillText = complexityId => {
        const { complexityList } = this.state
        const idx = complexityList.findIndex(c => c._id === complexityId)
        if (idx >= 0) {
            return complexityList[idx].title.substr(0, 1)
        } else {
            return complexityList[0].title.substr(0, 1)
        }
    }

    openAnswer = (idx, question) => {
        let { showAnswer, activeTabIndex } = this.state
        if (!showAnswer[activeTabIndex]) showAnswer[activeTabIndex] = []
        showAnswer.forEach((answer, sIdx) => {
            if (answer?.length) {
                answer.forEach((ans, aIdx) => {
                    if (idx !== aIdx) {
                        showAnswer[sIdx][aIdx] = false
                    }
                })
            }
        })
        showAnswer[activeTabIndex][idx] = !showAnswer[activeTabIndex][idx]
        this.setState({
            showAnswer
        })
    }

    setSelectedQuestionMenu = val => {
        this.setState({
            selectedQuestionMenu: val
        })
    }

    goToNextStep = _ => {
        this.setState({
            step: this.state.step + 1
        })
    }

    renderAnswer = question => {
        return (
            <div className="answer-list">
                {question?.content?.isMultiStep ?
                    question.content?.steps.map(step => (
                        <div className="multi-step">
                            <label dangerouslySetInnerHTML={{ __html: step?.content?.title?.replace(/<(.|\n)*?>/g, '').replace(/\&nbsp;/g, " ") }}></label>
                            <ul>
                                {step?.content?.options.map(option => (
                                    <li>
                                        <div className='radio-container'>
                                            <div className={`custom-radio ${option.isCorrect && 'active'}`}>
                                                <div className='radio-button'>{option.isCorrect && <div></div>}</div>
                                                <div className='radio-label' dangerouslySetInnerHTML={{ __html: option?.content?.replace(/<(.|\n)*?>/g, '').replace(/\&nbsp;/g, " ") }}></div>
                                            </div>
                                        </div>
                                    </li>

                                ))}
                            </ul>
                        </div>
                    )) :
                    <ul>
                        {question?.content?.options.map(option => (
                            <li>
                                <div className='radio-container'>
                                    <div className={`custom-radio cursor-pointer ${option.isCorrect && 'active'}`}>
                                        <div className='radio-button'>{option.isCorrect && <div></div>}</div>
                                        <div className='radio-label' dangerouslySetInnerHTML={{ __html: option?.content?.replace(/<(.|\n)*?>/g, '').replace(/\&nbsp;/g, " ") }}></div>
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                }
            </div>
        )
    }

    renderPickQuestions() {
        const {
            step,
            payload
        } = this.state

        return (
            <Modal className="cw-custom-modal modal-pick-questions" isOpen={true} toggle={this.hidePickQuestions} size={"xl"}>
                <ModalBody >
                    <div className="row px-2">
                        <div className="col text-right">
                            <img className="close-icon cursor-pointer" onClick={this.hidePickQuestions} src={getImageSource(ImageConstants.CROSS)} />
                        </div>
                    </div>
                    <div className="px-5">
                        <ul className='steps'>
                            <>
                                {payload?.questionSource !== "countingwell" &&
                                    <li className={`step cursor-pointer ${(step === 1 || step > 1) ? "active" : ""}`} onClick={_ => {
                                        if (step > 1) {
                                            this.pickFromBank(1)
                                        }
                                    }}>
                                        {step > 1 && <img className='step-image' src={getImageSource(ImageConstants.TICK_WHITE)} />}<p className='step-title'>1. PICK</p>
                                    </li>
                                }
                                <li className={`step cursor-pointer ${(step === 2 || step > 2 || (step === 1 && payload?.questionSource === "countingwell")) ? "active" : ""}`} onClick={_ => {
                                    if (step > 2) {
                                        this.pickFromBank(2)
                                    }
                                }}>
                                    {step > 2 && <img className='step-image' src={getImageSource(ImageConstants.TICK_WHITE)} />}<p className='step-title'>{payload?.questionSource === "countingwell" ? "1." : "2."} REVIEW</p>
                                </li>
                                <li className={`step ${step === 3 || step > 3 ? "active" : ""}`}>
                                    {step > 3 && <img className='step-image' src={getImageSource(ImageConstants.TICK_WHITE)} />}<p className='step-title'>{payload?.questionSource === "countingwell" ? "2." : "3."} CREATE</p>
                                </li>
                            </>

                        </ul>
                        <div className='pick-questions'>
                            {step === 1 && this.renderPickStep()}
                            {step === 2 && this.showQuestionDetail()}
                            {step === 3 && this.renderCreateAssesmentStep()}
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        )
    }

    onFilterGo = _ => {
        this.getSchoolQuestionSet()
    }

    clearSearch = _ => {
        const { selectedChapters } = this.state;
        let selectedChapter = ""

        if (selectedChapters.length > 0) {
            selectedChapter = selectedChapters[0];
            this.dropdown.onClickOption(selectedChapter)
        } else {
            this.dropdown.resetSelectText()
        }
        this.setState({
            search: "",
            complexity: "",
            selectedChapter,
            questionSet: {}
        }, _ => {
            this.getSchoolQuestionSet()
            this.complexityDropdown.resetSelectText()
        })
    }

    renderPickStep = _ => {
        const {
            selectedChapter,
            selectedChapters,
            search,
            questionSet,
            selectedQuestions,
            complexityList,
            complexity,
            activeTabIndex,
            showAnswer
        } = this.state
        return (
            <>
                <div className='tab-container px-4'>
                    <div className='tab-inner-container'>

                        <div
                            key={'tab0'}
                            className={`tab mr-3 ${activeTabIndex == 0 ? 'tab-active' : ''
                                }`}
                            onClick={() => this.onClickTab(0, "Qs. Bank")}
                        >
                            <div className='tab-center'>
                                <span>Qs. Bank</span>
                            </div>

                            {activeTabIndex == 0 ? (
                                <div className='active-cirlce'></div>
                            ) : (
                                ''
                            )}
                        </div>
                        <div
                            key={'tab1'}
                            className={`tab mr-3 ${activeTabIndex == 1 ? 'tab-active' : ''
                                }`}
                            onClick={() => this.onClickTab(1, "Selected")}
                        >
                            <div className='tab-center'>
                                <span>Selected</span>
                                {selectedQuestions?.length > 0 &&
                                    <span className="ques-count">{selectedQuestions?.length}</span>
                                }
                            </div>

                            {activeTabIndex == 1 ? (
                                <div className='active-cirlce'></div>
                            ) : (
                                ''
                            )}
                        </div>
                    </div>
                </div>
                {activeTabIndex === 0 &&
                    <div className='modal-filters px-3'>
                        <div className='row m-0 mr-2'>
                            {selectedChapters?.length > 0 &&
                                <Dropdown
                                    ref={el => this.dropdown = el}
                                    key="chapter-multi-select"
                                    placeholder='Select Chapter'
                                    options={selectedChapters}
                                    onSelect={(option) => this.onSelect(option, "selectedChapter")}
                                    text={"title"}
                                    value={selectedChapter?.value}
                                    style={{ background: "#F9F9F9" }}
                                />
                            }
                        </div>
                        <div className="row m-0 search ml-2">
                            <div className="col-10">
                                <input className={`search-input`} placeholder='Search'
                                    value={search}
                                    onChange={(e) => this.onChangeHandler(e, 'search')} />
                            </div>
                            <div className="col-2 my-auto text-right"><img className='search-icon cursor-pointer' src={getImageSource(ImageConstants.SEARCH)} /></div>
                        </div>
                        <div className='complexity ml-2'>
                            {complexityList?.length && (
                                <Dropdown
                                    ref={el => this.complexityDropdown = el}
                                    text='title'
                                    placeholder='Select Complexity'
                                    options={complexityList}
                                    onSelect={option => this.onSelect(option, 'complexity')}
                                    value={complexity?.value}
                                    style={{ background: "#F9F9F9" }}
                                />
                            )}
                        </div>
                        <div className='filter-buttons'>
                            <button
                                className={`cw-btn-secondary add-questions ml-2`}
                                onClick={_ => this.onFilterGo()}
                            >
                                Go
                            </button>
                            <button
                                className={`cw-btn-secondary add-questions ml-2`}
                                onClick={_ => this.clearSearch()}
                            >
                                Clear
                            </button>
                        </div>
                        <div className='add-questions-container'>
                            <button
                                className='cw-btn-md cw-btn-primary add-questions ml-4'
                                onClick={this.openAddQuestion}
                            >
                                New Question
                            </button>
                        </div>
                    </div>
                }
                <div className='question-set-list'>
                    {activeTabIndex === 0 && questionSet && questionSet.questions?.length > 0 &&
                        questionSet.questions.map((question, index) => {
                            return (<>
                                {question.content && (
                                    <div className='question-answer-container'>
                                        <div className='question'>
                                            <div className={`name checkbox-alignment ${selectedQuestions.findIndex(q => q.id === question.id?.toString()) >= 0 ? 'active' : ''}`}
                                                onClick={_ => {
                                                    if (selectedQuestions.findIndex(q => q.id === question.id?.toString()) >= 0) {
                                                        this.showQuestionRemoveConfirmModal(question)
                                                    } else {
                                                        this.onSelectQuestion(question)
                                                    }
                                                }
                                                }
                                            >
                                                <div className='custom-checkbox'>
                                                    {selectedQuestions.findIndex(q => q.id === question.id?.toString()) >= 0 ? (
                                                        <div className='tick-mark'></div>
                                                    ) : (
                                                        ''
                                                    )}
                                                </div>
                                                <div className='chekbox-title'>
                                                    <span dangerouslySetInnerHTML={{ __html: question?.content?.title.replace(/<(.|\n)*?>/g, '') }}></span>
                                                </div>
                                            </div>
                                            <div className='question-right'>
                                                {question?.mandatoryAttachments?.image && (
                                                    <span className='question-score'>
                                                        <img className='score-icn' src={getImageSource(ImageConstants.CAMERA)} />
                                                    </span>
                                                )}
                                                <span className='question-score'>
                                                    <img
                                                        className={`score-icn ${question.content?.isMultiStep ? "multi-step" : ""}`}
                                                        src={getImageSource(
                                                            question.content?.isMultiStep
                                                                ? ImageConstants.TREE_LINE_ICN_BLACK
                                                                : ImageConstants.TREE_LINE_SINGLE_ICN_BLACK
                                                        )}
                                                    />
                                                </span>
                                                <span className='question-score'>
                                                    <img className='score-icn' src={getImageSource(ImageConstants["SKILL_" + question.content?.complexity?.toUpperCase() + "_ICN"])} /><span>{question.content?.complexity?.substr(0, 1)}</span>
                                                </span>
                                                <span className='question-score'>
                                                    <img className='score-icn' src={getImageSource(ImageConstants.MARK_ICN)} /><span>{question.content?.mark}</span>
                                                </span>
                                                <span
                                                    className='accordion-icn cursor-pointer'
                                                    onClick={_ =>
                                                        this.openAnswer(index, question)
                                                    }
                                                >
                                                    <FontAwesomeIcon
                                                        icon={
                                                            showAnswer[activeTabIndex] && showAnswer[activeTabIndex][index] ? faAngleUp : faAngleDown
                                                        }
                                                    />
                                                </span>
                                            </div>
                                        </div>
                                        {showAnswer[activeTabIndex] && showAnswer[activeTabIndex][index] && (
                                            this.renderAnswer(question)
                                        )}
                                    </div>
                                )}
                            </>)
                        })
                    }
                    {activeTabIndex === 1 && (
                        this.renderTreeView()
                    )}
                    {(!questionSet || !questionSet.questions?.length) && <div className='text-center pt-3'><strong>No Question Found</strong></div>}
                </div>
                <div className='text-center next-button'>
                    {this.state.selectedQuestions?.length > 0 &&
                        <button className='cw-btn-md cw-btn-primary' onClick={this.setAssessmentQuestions}>
                            NEXT
                        </button>
                    }
                </div>
            </>
        )
    }

    renderTreeView = _ => {
        console.log(this.state.payload?.questionSource)
        console.log(this.state.payload?.duration)
        const { selectedQuesByChapter, selectedQuesByComplexity, selectedQuestionMenu, selectedQuestions, selectedChapter, showAnswer } = this.state
        return (
            <>
                <div className='question-details'>
                    <span>Total Qs. Selected: <strong>{selectedQuestions?.length || 0}</strong></span>
                    <span>Estimated Time: <strong>{this.state.payload?.questionSource !== "questionbank" ?
                        this.state.payload?.duration || 15 :
                        this.getEstimatedTime()} mins</strong></span>
                    <span>Total Marks: <strong>{this.getTotalMarks()}</strong></span>
                </div>
                <div className='help-text'>
                    <span><img className='info-icn' src={getImageSource(ImageConstants.INFO)} />Selected questions are shown in order of complexity to students</span>
                </div>
                {selectedQuestionMenu === 1 && selectedQuesByChapter && Object.keys(selectedQuesByChapter)?.length > 0 && (
                    this.renderChapterWiseQuestionList()
                )}
                {selectedQuestionMenu === 2 && selectedQuesByComplexity && Object.keys(selectedQuesByComplexity)?.length > 0 && (
                    this.renderComplexityWiseQuestionList()
                )}
            </>
        )
    }

    renderChapterWiseQuestionList = _ => {
        const { selectedQuesByChapter, showAnswer, activeTabIndex, selectedQuestionMenu } = this.state
        return (
            <>
                {Object.keys(selectedQuesByChapter).map((chapter, cIndex) => (
                    <div>
                        <div class="selected-ques-list">
                            <div className='chapter-details'>
                                <div className='chapter-title'>{chapter}</div>
                                {
                                    cIndex === 0 && (
                                        <div className='toggle-icons'>
                                            <span
                                                className={`cursor-pointer ${selectedQuestionMenu === 1 ? 'active' : ''
                                                    }`}
                                                onClick={_ => this.setSelectedQuestionMenu(1)}
                                            >
                                                <img src={getImageSource(ImageConstants.GRID_ICN)} />
                                            </span>
                                            <span
                                                className={`cursor-pointer ${selectedQuestionMenu === 2 ? 'active' : ''
                                                    }`}
                                                onClick={_ => this.setSelectedQuestionMenu(2)}
                                            >
                                                <img src={getImageSource(ImageConstants.TREE_ICN)} />
                                            </span>
                                        </div>
                                    )
                                }


                            </div>
                            {selectedQuesByChapter[chapter]?.length > 0 && selectedQuesByChapter[chapter].map((question, index) =>
                                <div className='question-answer-container'>
                                    <div className='question'>
                                        <div className='question-title' dangerouslySetInnerHTML={{ __html: question?.content?.title.replace(/<(.|\n)*?>/g, '').replace(/\&nbsp;/g, " ") }}></div>
                                        <div className='question-right'>
                                            {question?.mandatoryAttachments?.image && (
                                                <span className='question-score'>
                                                    <img className='score-icn' src={getImageSource(ImageConstants.CAMERA)} />
                                                </span>
                                            )}
                                            <span className='question-score'>
                                                <img
                                                    className={`score-icn ${question.content?.isMultiStep ? "multi-step" : ""}`}
                                                    src={getImageSource(
                                                        question.content?.isMultiStep
                                                            ? ImageConstants.TREE_LINE_ICN_BLACK
                                                            : ImageConstants.TREE_LINE_SINGLE_ICN_BLACK
                                                    )}
                                                />
                                            </span>
                                            <span className='question-score'>
                                                <img className='score-icn' src={getImageSource(ImageConstants["SKILL_" + question.content?.complexity?.toUpperCase() + "_ICN"])} /><span>{question.content?.complexity?.substr(0, 1)}</span>
                                            </span>
                                            <span className='question-score'>
                                                <img className='score-icn' src={getImageSource(ImageConstants.MARK_ICN)} /><span>{question.content?.mark}</span>
                                            </span>
                                            <span
                                                className='accordion-icn cursor-pointer'
                                                onClick={_ =>
                                                    this.openAnswer(index, question)
                                                }
                                            >
                                                <FontAwesomeIcon
                                                    icon={
                                                        showAnswer[activeTabIndex] && showAnswer[activeTabIndex][index] ? faAngleUp : faAngleDown
                                                    }
                                                />
                                            </span>
                                            <span className='question-score cursor-pointer'
                                                onClick={_ =>
                                                    this.showQuestionRemoveConfirmModal(question, chapter)
                                                }>
                                                <img className='score-icn' src={getImageSource(ImageConstants.DELETE_RED)} />
                                            </span>
                                        </div>
                                    </div>
                                    {showAnswer[activeTabIndex] && showAnswer[activeTabIndex][index] && (
                                        this.renderAnswer(question)
                                    )}
                                </div>
                            )}
                        </div>

                    </div>
                ))
                }
            </>
        )
    }

    renderComplexityWiseQuestionList = _ => {
        const { selectedQuesByComplexity, showAnswer, activeTabIndex, selectedQuestionMenu } = this.state
        return (
            <>
                {Object.keys(selectedQuesByComplexity).map((compleixty, cIndex) => (
                    <div>
                        <div class="selected-ques-list">
                            <div className='chapter-details'>
                                <div className='chapter-title'>
                                    <img src={getImageSource(ImageConstants["SKILL_" + compleixty.toUpperCase() + "_ICN"])} />
                                    <span>{compleixty}</span>
                                </div>
                                {
                                    cIndex === 0 && (
                                        <div className='toggle-icons'>
                                            <span
                                                className={`cursor-pointer ${selectedQuestionMenu === 1 ? 'active' : ''}`}
                                                onClick={_ => this.setSelectedQuestionMenu(1)}
                                            >
                                                <img src={getImageSource(ImageConstants.GRID_ICN)} />
                                            </span>
                                            <span
                                                className={`cursor-pointer ${selectedQuestionMenu === 2 ? 'active' : ''}`}
                                                onClick={_ => this.setSelectedQuestionMenu(2)}
                                            >
                                                <img src={getImageSource(ImageConstants.TREE_ICN)} />
                                            </span>
                                        </div>
                                    )}
                            </div>
                            {selectedQuesByComplexity[compleixty]?.length > 0 && selectedQuesByComplexity[compleixty].map((question, index) =>
                                <div className='question-answer-container'>
                                    <div className='question'>
                                        <div className='question-title' dangerouslySetInnerHTML={{ __html: question?.content?.title.replace(/<(.|\n)*?>/g, '').replace(/\&nbsp;/g, " ") }}></div>
                                        <div className='question-right'>
                                            {question?.mandatoryAttachments?.image && (
                                                <span className='question-score'>
                                                    <img className='score-icn' src={getImageSource(ImageConstants.CAMERA)} />
                                                </span>
                                            )}
                                            <span className='question-score'>
                                                <img
                                                    className={`score-icn ${question.content?.isMultiStep ? "multi-step" : ""}`}
                                                    src={getImageSource(
                                                        question.content?.isMultiStep
                                                            ? ImageConstants.TREE_LINE_ICN_BLACK
                                                            : ImageConstants.TREE_LINE_SINGLE_ICN_BLACK
                                                    )}
                                                />
                                            </span>
                                            <span className='question-score'>
                                                <img className='score-icn' src={getImageSource(ImageConstants.MARK_ICN)} /><span>{question.content?.mark}</span>
                                            </span>
                                            <span
                                                className='accordion-icn cursor-pointer'
                                                onClick={_ =>
                                                    this.openAnswer(index, question)
                                                }
                                            >
                                                <FontAwesomeIcon
                                                    icon={
                                                        showAnswer[activeTabIndex] && showAnswer[activeTabIndex][index] ? faAngleUp : faAngleDown
                                                    }
                                                />
                                            </span>
                                            <span
                                                className='question-score cursor-pointer'
                                                onClick={_ =>
                                                    this.showQuestionRemoveConfirmModal(question)
                                                }
                                            >
                                                <img className='score-icn' src={getImageSource(ImageConstants.DELETE_RED)} />
                                            </span>
                                        </div>
                                    </div>
                                    {showAnswer[activeTabIndex] && showAnswer[activeTabIndex][index] && (
                                        this.renderAnswer(question)
                                    )}
                                </div>
                            )}
                        </div>

                    </div>
                ))
                }
            </>
        )
    }

    getTotalMarks = _ => {
        const { selectedQuestions } = this.state
        let totalMarks = 0
        if (selectedQuestions?.length) {
            selectedQuestions.map(q => {
                if (q.content?.mark) totalMarks += parseInt(q.content?.mark)
            })
        }
        return totalMarks
    }

    getEstimatedTime = _ => {
        const { selectedQuestions } = this.state
        let duration = 0
        if (selectedQuestions?.length) {
            selectedQuestions.map(q => {
                if (q.content?.complexity === "Low") {
                    duration += 1
                } else if (q.content?.complexity === "Medium") {
                    duration += 3
                } else if (q.content?.complexity === "High") {
                    duration += 5
                }
            })
        }
        return duration
    }

    getTotalQuestionMarks = _ => {
        const { questions } = this.state
        let totalMarks = 0
        if (questions?.length) {
            questions.map(q => {
                if (q.content?.mark) totalMarks += parseInt(q.content?.mark)
            })
        }
        return totalMarks
    }

    renderCreateAssesmentStep = () => {
        let chapters = this.state.payload?.chapters || []
        return (
            <>
                <div className='question-set-list'>

                    <div className="m-4 assessment-info-card">
                        <div>
                            <div className="row">
                                <div className='col-4 text-center'>
                                    <div>
                                        <div className='text-center'><strong className='count'>{this.state.questions?.length || 0}</strong></div>
                                        <div className='sub-title'>Number of Qs. </div>
                                    </div>
                                </div>
                                <div className='col-4 text-center'>
                                    <div>
                                        <div className='text-center'><strong className='count'>{this.getTotalQuestionMarks()}</strong></div>
                                        <div className='sub-title'>Marks</div>
                                    </div>
                                </div>
                                <div className="col-4 text-center">
                                    <div className='text-center'><strong className='count'>{this.state.payload?.questionSource != "questionbank" ?
                                        this.state.payload?.duration || 15 :
                                        this.getEstimatedTime()}</strong> <span className="sub-title">mins</span></div>
                                    <div className='sub-title'>Duration</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="separator-outer">
                        <span className='separator'></span>
                    </div>

                    {
                        chapters?.length > 0 ?
                            <div className="mt-4 assessment-info-card text-center">
                                <div className="pt-2">
                                    <div className="chapter-header">
                                        Chapters Selected
                                    </div>
                                    <ul>
                                        {
                                            chapters.map(item => (
                                                <li className="pt-2 sub-title">
                                                    {
                                                        item.title
                                                    }
                                                </li>
                                            ))
                                        }
                                    </ul>
                                </div>
                            </div>
                            : ""
                    }
                </div>
                <div className='text-center next-button'>
                    <span className="pr-4"> {this.state.errMessage ? <span className="text-danger"><small><b>{this.state.errMessage}</b></small></span> : ""}</span>
                    <button className='cw-btn-md cw-btn-primary' onClick={_ => this.pickFromBank(2)}>
                        Back
                    </button>
                    {this.state.questions?.length > 0 &&
                        <button className='cw-btn-md cw-btn-primary' onClick={this.onClickCreate}>
                            CREATE
                        </button>
                    }
                </div>
            </>
        )
    }

    renderTestCard = () => {
        // console.log(this.state.payload);
        let chapters = this.state.payload?.chapters || []
        return (
            <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12">
                    <div className="m-4 assessment-info-card">
                        <div>
                            <div className="row">
                                <div className='col-12 text-center'>
                                    <div>
                                        <div className='text-center'><strong className='count'>{this.state.totalStudents || 0}</strong></div>
                                        <div className='sub-title'>Registered Students </div>
                                    </div>
                                </div>
                                <div className="col-12 text-center my-2">
                                    <img className='seperator' src={getImageSource(ImageConstants.FILTER_SEPERATOR)} />
                                </div>
                                <div className='col-12 text-center'>
                                    <div>
                                        <div className='text-center'><strong className='count'>{this.state.questions?.length || 0}</strong></div>
                                        <div className='sub-title'>Number of Qs.</div>
                                    </div>
                                </div>
                                <div className="col-12 text-center my-2">
                                    <img className='seperator' src={getImageSource(ImageConstants.FILTER_SEPERATOR)} />
                                </div>
                                <div className="col-12 text-center">
                                    <div className='text-center'>
                                        <strong className='count'>
                                            {this.state.payload?.questionSource != "questionbank" ?
                                                this.state.payload?.duration || 15 :
                                                this.getEstimatedTime()}
                                        </strong> mins
                                    </div>
                                    <div className='sub-title'>Approximate Time</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12">
                    {
                        chapters?.length > 1 ?
                            <div className="mt-4 assessment-info-card">
                                <div className="pt-2">
                                    <div className="chapter-header">
                                        Chapters
                                    </div>
                                    <ul>
                                        {
                                            chapters.map(item => (
                                                <li className="pt-2 sub-title">
                                                    {
                                                        item.title
                                                    }
                                                </li>
                                            ))
                                        }
                                    </ul>
                                </div>
                            </div>
                            : ""
                    }
                </div>
            </div>
        )

    }

    saveQuestions = questions => {
        this.setState({
            questions
        })
    }


    onClickCreateDiganosticAssessment() {


        if (!this.state.questions.length) {
            // console.log(this.state.questions)
            return
        }

        this.setState({ isCreate: true })

        let type = this.props.type
        if (this.saving) return
        let payload = {
            ...this.state.payload,
            type: type ? type : this.props.type
        }
        payload.approximateQuestions = this.state.questionCount || 0
        payload.approximateTime = this.state.approximateTime || 0


        let validation = this.validatePayloadForDiagnosticAssessment(payload)

        if (!validation) {
            this.setState({ isCreate: false, isLoading: false })
            return
        }

        payload.questions = this.getQuestionPayload(this.state.questions || [])

        if (!payload.questions.length) {
            this.setState({ errMessage: "No Questions Available" })
            return;
        }

        this.setState({ isLoading: true })

        if (!this.state.studentListLength) {
            console.log('No Students having Roll Number')
            alert("No Students Found with Roll Number")
            return;
        }



        TestApi.createJigyasaAssessment(payload).then(response => {
            this.saving = false
            this.setState({ isLoading: false, showPickQuestions: false })
            let assessment = { ...response.data, ...payload, created: true }
            if (!assessment.totalUsers) {
                this.props?.delegate?.onCLickNotitification && this.props.delegate.onCLickNotitification(assessment, "WHATSAPP")
            } else {
                this.props?.delegate?.showSuccessModal && this.props.delegate.showSuccessModal(assessment)
                // this.props?.delegate?.showSuccessMessage && this.props.delegate.showSuccessMessage()
            }
            if (assessment.point) {
                this.props?.delegate?.showRewardToaster && this.props.delegate.showRewardToaster(assessment.point)
            }
            this.props?.delegate?.hideNewTest && this.props.delegate.hideNewTest(true)
        }).catch(err => {

            this.saving = false

            this.setState({ isLoading: false })
        })

    }

    validatePayloadForDiagnosticAssessment(payload, leaveQuestions) {

        if (this.user.subjectId === Constants.SCIENCE_SUBJECTID && !payload.subSubjectId) {
            this.setState({ errMessage: "Please Select the Subject" })
            return false
        }

        // if (this.user.subjectId === Constants.SCIENCE_SUBJECTID &&
        //     !payload.clickerAssessmentTitle && payload.subSubjectId.length > 1) {
        //     this.setState({ errMessage: "Please Enter Clicker Assessment title" })
        //     return false
        // }

        if (!payload?.board) {
            this.setState({ errMessage: "Please Select the Board" })
            return false
        }

        if (!payload?.schoolId) {
            this.setState({ selectSchoolMessage: true })
            return false
        }

        if (!payload?.class) {
            this.setState({ errMessage: "Please Select the Class" })
            return false
        }

        if (!payload.section) {
            this.setState({ errMessage: "Please Select the Section" })
            return false
        }

        if (!payload.sectionId.length) {
            this.setState({ errMessage: "Please Select the Section" })
            return false
        }



        // if (!payload.duration) {
        //     this.setState({ errMessage: "Please Select the Duration" })
        //     return false
        // }

        if (!payload.dueDate && payload.type != Constants.CLICKER_ASSESSMENT) {
            this.setState({ selectedDueDateMessage: true })
            return false
        }

        // if (!payload.medium) {
        //     this.setState({ selectedMediumMessage: true })
        //     return false
        // }



        // if (!payload?.questions?.length) {
        //     this.setState({ errMessage: "No Questions Available" })
        //     return false
        // }

        this.setState({ errMessage: "" })
        return true
    }



    renderStudentCard = (student, category, index, draggable) => {
        return (
            <div className={`cw-card student ${draggable ? "drag-hand px-2 pb-2" : "p-2"}`}
                onDragStart={(e) => this.onDragStart(e, { student, category, index })}
                onDragEnd={(e) => this.onDragEnd(e)}
                draggable={draggable}>

                {draggable && <div className="drag-icon"> <img className='cursor-pointer' src={getImageSource(ImageConstants.DRAG)} /></div>}

                <div className=" flex">
                    <div className="pl-2 d-inline-block">
                        <div className="student-name">{student?.name}</div>
                    </div>
                </div>
            </div>
        )
    }

    renderStandard = () => {
        return (
            <div id="table-scoll" className="table-responsive mt-8">
                <table className="table cw-table mb-0 align-items-center">

                    <tbody className="bg-white">
                        {
                            this.state.studentList?.length ? this.state.studentList?.map(students => (
                                <tr key={Math.random()} className="">
                                    {
                                        students?.map((item, index) => (
                                            <td className="text-center p-3">{this.renderStudentCard(item)}</td>
                                        ))
                                    }
                                </tr>
                            ))
                                : <tr className="bg-white pt-4"><td colSpan="5" align='center'>No Records found</td></tr>
                        }
                    </tbody>
                </table>
            </div >
        )
    }

    changeTab(item) {

        this.setState({ selectedTab: item.value })
    }

    setSelectedQuestions = (selectedContent) => {
        console.log(selectedContent)
        // this.hideQuestionList()

        const element = document.getElementById("CLICKER_ASSESSMENT_FILTER");
        console.log(element)
        element.scrollIntoView({ behavior: "instant", block: 'center' })
        this.showToaster('info', "Selected Questions have been applied")

        if (selectedContent && selectedContent.selectedContentAssessment) {
            this.setState({
                ...selectedContent,
            })
        }
    }

    showToaster(type, message) {
        this.setState({
            showToaster: true,
            toasterMessage: message,
            toasterType: type
        }, () => {
            setTimeout(() => { this.hideToaster() }, 6000);
        });
    }

    hideToaster() {
        this.setState({
            showToaster: false
        });
    }

    renderTabs = () => {

        return (
            <>
                <div className='row tab-header mt-4'>
                    {
                        this.tabs.map(item => (
                            <div className={`cursor-pointer col d-flex justify-content-center align-items-center ${this.state.selectedTab === item.value ? 'selected-tab-title' : ''}`}
                                onClick={() => this.changeTab(item)}>{item.title}
                                {
                                    item.value === 1 ? `${this.state.studentListLength ? `(${this.state.studentListLength})` : ''}` : ""
                                }
                            </div>
                        ))
                    }
                </div>
                {
                    this.state.selectedTab === 1 ?
                        this.renderStandard()
                        :
                        <></>
                }

                {
                    this.state.selectedTab === 2 && this.state.contents && this.state.contents.length && !this.state.isLoading && !this.state.isCreate ?
                        <>
                            <QuestionList back={this.hideQuestionList} contents={this.state.contents}
                                contentsHash={this.state.selectedContentAssessment ? this.state.contentsHash : {}}
                                questionSelection={true}
                                questionCount={this.state.isAdaptive ? this.state.categories[this.state.selectedIndex].questionCount : (this.state.questionCount || 0)}
                                approximateTime={this.state.isAdaptive ? this.state.categories[this.state.selectedIndex].approximateTime : (this.state.approximateTime || 0)}
                                showTimer={this.state.payload?.showTimer}
                                showCompetencyOnly={this.state.showCompetencyQuestionsOnly}
                                delegate={this}
                                isCreate={this.state.isCreate} />
                        </>
                        :
                        this.state.selectedTab === 2 ?
                            <div className='mt-2 d-flex justify-content-center'>No Questions Found</div>
                            :
                            <></>
                }
            </>
        )
    }


    render() {
        let chapters = []
        if (this.state.payload && this.state.payload.chapters?.length) {
            chapters = this.state.payload.chapters.map(chapter => {
                return {
                    value: chapter.key,
                    title: chapter.title
                }
            })
        }
        return (
            <div className='new-test'>

                <div>
                    <img alt="" className='report-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                </div>

                <div className="row pt-4" >
                    <div className="col-4 screen-title my-auto">New Classroom {this.props.type == "DIAGNOSTIC" ? "Chapter Readiness Test" : "Assessment"} </div>
                </div>

                <div className='mb-4'>
                    <div id='CLICKER_ASSESSMENT_FILTER' className="">
                        <Filter ref={el => this.filterRef = el}
                            onGo={this.handleFilter}
                            onBoardChange={this.onBoardChange}
                            type={this.props.type}
                            showPickQuestions={this.showPickQuestions}
                            resetSelectedQuestions={this.resetSelectedQuestions}
                            selectedHomework={this.props.selectedHomework}
                            isClonePractice={this.props.isClonePractice}
                        />
                        <div className="pr-4"> {this.state.errMessage ? <div className="text-danger"><small><b>{this.state.errMessage}</b></small></div> : ""}</div>

                        {
                            this.state.payload?.assessmentType === 'CHAPTER' ?
                                <>
                                    {this.state.payload?.board && this.state.payload?.class &&
                                        <button
                                            className={`cw-btn-md cw-btn-primary ${!this.state.payload?.board || !this.state.payload?.class || !this.state.payload?.chapters?.length || !this.state.payload?.duration || !this.state.payload?.dueDate ? "cw-button-disabled" : ""}`}
                                            onClick={_ => {
                                                this.pickFromBank(this.state.payload?.questionSource === "countingwell" ? 2 : 1)
                                            }
                                            }>
                                            CONTINUE
                                        </button>
                                    }
                                </>
                                :
                                this.state.payload?.assessmentType === 'DIAGNOSTIC' ?
                                    <div className='mt-4 text-right'>
                                        {this.state.payload?.board && this.state.payload?.class &&
                                            <button
                                                className={`cw-btn-md cw-btn-primary ${!this.state.payload?.board ||
                                                    !this.state.payload?.class ||
                                                    !this.state.payload?.section || !this.state.payload?.chapters.length ? "cw-button-disabled" : ""}`}
                                                onClick={_ => {
                                                    this.onClickCreateDiganosticAssessment()
                                                }
                                                }>
                                                Create
                                            </button>
                                        }
                                    </div>
                                    :
                                    <></>
                        }
                    </div>
                </div>

                {
                    this.state.payload?.chapters?.length ?
                        <div key={"1-row"} className=" qs-margin-top p-2">
                            <span className="table-row-1 p-2 ml-3">
                                <img className='question-mark-icon' src={getImageSource(ImageConstants.WHITE_QUESTION_MARK)} />
                                <span>
                                    <span className='question-number-text'>Number of Questions</span> <b className="pl-2"> {this.state.questionCount || 0}</b></span>
                            </span>
                            <span className="table-row-1  p-2 ml-5">
                                <img className='question-mark-icon' src={getImageSource(ImageConstants.WHITE_TIMER_ICON)} />
                                <span><span className='question-number-text'>Approximate Time</span> <b className="pl-2">{this.state.approximateTime || 0} </b>mins</span>
                            </span>
                        </div>
                        : <div className=" p-2 qs-margin-top"><div colSpan="5" align='center'><span>Please select a Chapter</span></div></div>
                }

                {
                    this.renderTabs()
                }

                {
                    this.state.showQuestionList ? this.showQuestionDetail() : ""
                }
                {
                    this.state.showPickQuestions ? this.renderPickQuestions() : ""
                }
                {this.state.showConfirmModal && <CWConfirm modal={this.state.showConfirmModal} close={this.hideConfirmModal} description={this.state.selectedContent} message={this.state.deleteMessage} onOk={this.onDeleteQuestion} />}
                {this.state.showQuestionRemoveConfirmModal && <CWConfirm modal={this.state.showQuestionRemoveConfirmModal} close={this.hideConfirmModal} description={this.state.deleteDescription} message={this.state.deleteMessage} onOk={this.removeSelectedQuestion} />}
                {this.state.openAddQuestion && <AddQuestion className={this.state.payload?.class} chapters={chapters} hideAddQuestion={this.hideAddQuestion} addQuestionsSuccess={this.addQuestionsSuccess} />}
                {this.state.showToaster ? <div className='custom-toaster-modal'> <ToasterComponent image={this.state.toasterImage} message={this.state.toasterMessage} type={this.state.toasterType} position="bottom-center" /></div> : ""}
            </div >);
    }
}

export default NewHomeWork;